<div fxLayout="row" fxLayoutAlign="start center">
  <button
    mat-icon-button
    class="mat-icon-button"
    (click)="editTask($event)"
    aria-label="Edit Task"
    matTooltip="Edit Task"
    *ngIf="!(locked || readOnly) && this.onSubjectDashboard === false"
  >
    <mat-icon class="clickkable edit">edit</mat-icon>
  </button>

  <button
    mat-icon-button
    class="mat-icon-button"
    (click)="editTask($event)"
    aria-label="View Task"
    matTooltip="View Task"
    *ngIf="(locked || readOnly) && this.onSubjectDashboard === false"
  >
    <mat-icon>open_in_new</mat-icon>
  </button>

  <div
    class="info"
    [ngClass]="{ 'pl-8': this.onSubjectDashboard === true }"
    fxFlexLayout="column"
    fxFlex="1 0 auto"
  >
    <div class="row-1" fxLayout="row" fxLayoutAlign="space-between center">
      <div
        class="pr-16"
        fxLayout="row wrap"
        fxFlex
        fxLayoutAlign="space-between center"
      >
        <div class="title" fxLayout="row" fxLayoutAlign="start center" fxFlex>
          <span class="text-truncate">{{ summary }}</span>
        </div>
        <div
          *ngIf="
            task.dateDue && task.taskStatus < 30 && (!locked || task?.readOnly)
          "
        >
          Due on {{ task.dateDue | dateFormat }}
        </div>
        <div *ngIf="task.taskStatus === 30">
          Completed on {{ task.dateCompleted | dateFormat }}
        </div>
        <div *ngIf="task.taskStatus === 40">
          Abandoned on {{ task.dateCompleted | dateFormat }}
        </div>
      </div>
    </div>

    <div class="row-2" fxLayout="row" fxLayoutAlign="space-between center">
      <div
        class="pr-8"
        fxLayout="row wrap"
        fxFlex
        fxLayoutAlign="space-between center"
      >
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxFlex
          *ngIf="this.onSubjectDashboard === false"
        >
          <a
            class="link text-truncate"
            *ngIf="
              this.task.subject &&
              !this.task.subject.isReferral &&
              this.onSubjectDashboard === false
            "
            [routerLink]="[
              '/subjects',
              this.subjectTypeService.getName(this.task.subject.subjectTypeId),
              this.task.subject.uid
            ]"
            matTooltip="View subject"
          >
            {{ getSubjectLine() }}
          </a>

          <a
            class="link text-truncate"
            *ngIf="
              this.task.subject &&
              this.task.subject.isReferral &&
              this.onSubjectDashboard === false
            "
            [routerLink]="[
              '/referrals/referrals/subject',
              this.task.subject.uid
            ]"
            matTooltip="View referral"
          >
            {{ getSubjectLine() }}
          </a>

          <div class="detail" *ngIf="!this.task.subject">Not linked</div>
        </div>

        <!-- <div class="detail">
                        {{getTaskTypeName()}}
                    </div> -->
      </div>
      <div fxLayout="row" fxLayoutAlign="end center" fxFlex>
        <div class="pr-16 detail text-truncate">
          {{ getTaskTypeName() }}
        </div>
      </div>
    </div>
  </div>

  <div class="actions" fxLayout="row" fxLayoutAlign="start center">
    <button
      mat-icon-button
      class="mat-icon-button"
      (click)="toggleStar($event)"
      aria-label="Toggle star"
      fxHide.xs
      [disabled]="locked"
      matTooltip="Toggle the 'Starred' flag"
    >
      <mat-icon *ngIf="task.starred" class="star">star</mat-icon>
      <mat-icon *ngIf="!task.starred">star_outline</mat-icon>
    </button>

    <button
      mat-icon-button
      class="mat-icon-button"
      (click)="toggleImportant($event)"
      aria-label="Toggle important"
      fxHide.xs
      [disabled]="locked"
      matTooltip="Toggle the 'Important' flag"
    >
      <mat-icon *ngIf="task.important" class="important">error</mat-icon>
      <mat-icon *ngIf="!task.important">error_outline</mat-icon>
    </button>

    <!-- <div>
      <add-to-calendar-button
        [attr.name]="this.calendarTitle"
        [attr.description]="this.calendarDescription"
        options="'Microsoft365', 'Outlook.com', 'MicrosoftTeams', 'iCal'"
        [attr.startDate]="this.calendarDateDue"
        [attr.endDate]="this.calendarDateDue"
        hideTextLabelButton
        buttonStyle="round"
        startTime="12:00"
        endTime="12:00"
        timeZone="Europe/London"
        listStyle="modal"
        matTooltip="Add to calendar"
      ></add-to-calendar-button>
    </div> -->

    <!-- <button
      id="btnAddToCalender"
      #btnAddToCalender    
      aria-label="Add to calendar"
      (click)="AddToCalendar($event)"      
      >
      <ng-container>
        <mat-icon>edit_calendar</mat-icon>      
      </ng-container>
    </button> -->

    <div class="mat-button-wrapper">
      <button
        mat-icon-button
        [matMenuTriggerFor]="moreMenu"
        *ngIf="task.taskStatus !== 30 && task.taskStatus !== 40"
        [style.visibility]="locked ? 'hidden' : 'visible'"
        aria-label="More"
        class="mat-icon-button"
        (click)="$event.stopPropagation()"
        fxHide.xs
        [disabled]="locked"
        matTooltip="More"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <button
        mat-icon-button
        class="mat-icon-button"
        *ngIf="task.taskStatus === 30"
        fxHide.xs
        matTooltip="This task is locked and cannot be changed"
        readonly="true"
        aria-label="Completed"
      >
        <mat-icon class="completed">done</mat-icon>
      </button>
      <button
        mat-icon-button
        class="mat-icon-button"
        *ngIf="task.taskStatus === 40"
        fxHide.xs
        matTooltip="This task is locked and cannot be changed"
        readonly="true"
        aria-label="Abandoned"
      >
        <mat-icon class="abandoned">clear</mat-icon>
      </button>
    </div>
    <mat-menu #moreMenu="matMenu">
      <button
        mat-menu-item
        aria-label="Mark as Completed"
        (click)="markTaskAsCompleted($event)"
        *ngIf="!locked"
      >
        <!-- <fuse-prompt-email-dialog></fuse-prompt-email-dialog> -->
        <ng-container>
          <mat-icon>check_box</mat-icon>
          <span>Mark as Completed</span>
        </ng-container>
      </button>
      <button
        mat-menu-item
        aria-label="Mark as Abandoned"
        (click)="markTaskAsAbandoned($event)"
        *ngIf="!locked"
      >
        <ng-container>
          <mat-icon>cancel_presentation</mat-icon>
          <span>Mark as Abandoned</span>
        </ng-container>
      </button>    

      <button
        id="btnAddToCalender"
        mat-menu-item
        #btnAddToCalender    
        aria-label="Add to calendar"
        (click)="AddToCalendar($event)"      
        >
        <ng-container>
          <mat-icon>edit_calendar</mat-icon>      
          Add to Calendar
        </ng-container>
      </button>

    </mat-menu>
  </div>
</div>
